export default __webpack_public_path__ + "static/media/Highlord's Band of Power.4b696d8c.jpg";